import './scss/main.scss'
import './scss/message.scss'

import shelltool from './js/shelltool'
import parseWxEmo from './js/parseWxEmo'
import content from './js/content'
import utils from './js/utils';

const initApp = () => {

    // Sentry.init({
    //   dsn: "https://adbce50847f8499e9c168d880af79568@sentry.weiyoubot.cn/8",
    //   integrations: [new Sentry.Integrations.BrowserTracing()],

    //   // Set tracesSampleRate to 1.0 to capture 100%
    //   // of transactions for performance monitoring.
    //   // We recommend adjusting this value in production
    //   tracesSampleRate: 1.0,
    // });

    window.winData = {sendWs: () => {}, resetTimeWs: 0};
    shelltool.init();

    var currentRef = document.referrer;
    var hasStarted = false;

    //判断 1、访问网页的来源是包含public域名的
    if(currentRef.indexOf('zhiniplugin.h5bqb.top') > 0){
        setTimeout(() =>{
            let channel_id = utils.getParameterByName("channel_id");
            window.location.href = `https://zhinikefu.com/?hmsr=wangyechajian&hmpl=illegal&channel_id=${channel_id}`;
        },2000)
    }else{
        
        // 只监听 postMessage（srcdoc 模式）
        window.addEventListener('message', function (event) {

            var data = event.data;
            switch (data.type) {
                case 'init': {
                
                    // 先设置环境信息到全局变量（供 ajaxutils 使用），无论是否 isHide
                    window._ZHINI_ENV = {
                        isLocalDev: data.isLocalDev || false,
                        baseUrl: data.baseUrl || ''
                    };
                
                    // 接收 postMessage 传递的参数
                    var shouldHideBtn = data.isHide; // 保存是否隐藏按钮的标志
                                    
                    // 启动应用（只启动一次）- 即使 isHide=true 也要启动，这样才能看到日志
                    if (!hasStarted && data.channel_id) {
                        // 先将参数存储到 localStorage
                        localStorage.setItem('zhini_channel_id', data.channel_id);
                                                            
                        // 注意：client_id 是通过 postMessage 传递的，InnerWeb 收到后直接使用
                        // 不需要再保存到 localStorage
                                                            
                        // 再启动应用
                        content.startProcess();
                        hasStarted = true;
                    }
                    break;
                }
                case 'ping': {
                    break;
                }
                default:
                    break;
            }
        }, false);
        
    }

};
initApp();



// WEBPACK FOOTER //
// ./src/index.js